import React from "react";
import SbEditable from "storyblok-react";
import FluidImage from "src/utils/FluidImage";
import RichText from 'src/utils/RichText'

const TestimonialLargeAvatar = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <section
        className="bg-darkgrey overflow-hidden"
        style={{ backgroundColor: blok.primary_colour }}
      >
        <div className="relative max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8 lg:py-20 md:py-12">
          <div className="relative flex md:flex-row flex-col md:items-end gap-8">
            <div className="md:pl-0 md:pb-0 block md:flex-shrink-0">
              <FluidImage
                className="object-cover object-center h-44 w-44"
                image={blok.image}
              />
            </div>
            <div className="relative">
              {blok.content_type === "magazine" ? (
                <h4
                  className="text-white mb-1 font-insights-display text-2xl leading-5 font-semibold"
                  style={{ color: blok.text_colour }}
                >
                  {blok.name}
                </h4>
              ) : (
                <h4 className="text-white mb-0 font-display text-3xl">
                  {blok.name}
                </h4>
              )}
              <div className="flex">
                <div className="ml-0">
                  <div className={`font-medium text-white ${blok.content_type === "magazine" ? "font-insights-display text-xl" : "text-sm"}`}>
                    {blok.job_title}
                  </div>
                  <div className={`font-medium text-white ${blok.content_type === "magazine" ? "font-insights-display text-xl" : "text-sm"}`}>
                    {blok.job_department}
                  </div>
                  <a
                    href={`mailto:${blok.email}`}
                    className={`block
                      ${blok.content_type === "magazine" ? "font-insights-display text-base" : "font-semibold text-sm"}
                    } text-red ${blok.display_bio_content ? '' : 'mt-5'} mb-2`}
                    style={{ color: blok.text_colour }}
                  >
                    {blok.email}
                  </a>
                  {blok.display_bio_content &&
                    <div className={`text-white ${blok.content_type === "magazine" ? "font-insights-display text-sm" : "text-sm"}`}>
                      <RichText>{blok.bio}</RichText>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  );
};

export default TestimonialLargeAvatar;
